import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import React from 'react';

const GROW_ACCOUNTS_COUNTER_QUERY = gql`
  query growAccountsCounterQuery($accountId: ID!) {
    account(id: $accountId) {
      growAccountsCounter {
        growAccountsInCountry
        growAccountsGlobally
      }
    }
  }
`;

const GrowAccountsCounter = ({ accountId }) => {
  const { loading, error, data } = useQuery(GROW_ACCOUNTS_COUNTER_QUERY, {
    variables: {
      accountId,
    },
  });

  if (loading || error) return null;

  if (data && data.account && data.account.growAccountsCounter) {
    return (
      <span>
        {`GROW: ${data.account.growAccountsCounter.growAccountsInCountry} | ${data.account.growAccountsCounter.growAccountsGlobally}`}
      </span>
    );
  }

  return null;
};

export default GrowAccountsCounter;
